import { BaseCanvasPack } from "./BaseCanvasPack";

const LEVEL_GRADIENTS: Array<{ top: string; bottom: string }> = [
  { top: "#1e3c72", bottom: "#2a5298" },
  { top: "#42275a", bottom: "#734b6d" },
  { top: "#0f2027", bottom: "#203a43" },
  { top: "#3a1c71", bottom: "#d76d77" },
  { top: "#232526", bottom: "#414345" },
  { top: "#1A2980", bottom: "#26D0CE" },
  { top: "#642B73", bottom: "#C6426E" },
  { top: "#19547b", bottom: "#ffd89b" },
  { top: "#355C7D", bottom: "#6C5B7B" },
  { top: "#141E30", bottom: "#243B55" },
];

export default class LevelBasedCanvasPack extends BaseCanvasPack {
  drawBackground(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number,
    level?: number
  ): void {
    const colors =
      LEVEL_GRADIENTS[(level ?? 0) % LEVEL_GRADIENTS.length] ??
      LEVEL_GRADIENTS[0];
    const gradient = context.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, colors.top);
    gradient.addColorStop(1, colors.bottom);
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);
  }

  /**
   * Draws the canvas frame - same as default
   */
  drawFrame(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {
    context.fillStyle = "rgba(0,0,0,0.2)";
    context.fillRect(0, 0, width, height);
    context.strokeStyle = "#FFF";
    context.lineWidth = 1;
    context.strokeRect(0.5, 0.5, width - 1, height - 1);
  }
}

